import { FC, ReactNode } from 'react';
import styled from 'styled-components';

import { SidePanelTitle } from '../status/SidePanelTitle';

export const StyledDiv = styled.div`
  flex-basis: 40em;
`;

interface SidePanelStructureProps {
  children: ReactNode;
}

export const SidePanelStructure: FC<SidePanelStructureProps> = ({ children }) => (
  <StyledDiv className="card card-bordered h-100 d-flex flex-column p-3 overflow-auto" data-e2e="side-panel">
    <SidePanelTitle />
    {children}
  </StyledDiv>
);
